export default __webpack_public_path__ + "static/jost-all-500-normal-58a77e1c7c35c4947c7df15d84728018.woff";